import React from "react";
import { observer } from "mobx-react";

import Group from "../../group";
import "./style.scoped.scss";

const ReportDocumentMetadataOverview = observer(({ document, readonly, onEdit }) => {
    const { variables, documentSettings } = document;

    return (
        <>
            <Group title="Document Metadata & Settings" onEdit={!readonly && onEdit}>
                <div className="metadata">
                    {variables.map((field, index) => (
                        <div className="variable" key={index}>
                            <div className="key">{field.label}</div>
                            <div className="value">{field.value}</div>
                        </div>
                    ))}
                </div>
                <div className="divider"></div>
                <div className="metadata">
                    <div className="variable">
                        <div className="key">Cover Page</div>
                        <div className="value">
                            {documentSettings?.generateCoverPage ? "Enabled" : "Disabled"}
                        </div>
                    </div>
                    <div className="variable">
                        <div className="key">Table of Contents</div>
                        <div className="value">
                            {documentSettings?.generateTableOfContents ? "Enabled" : "Disabled"}
                        </div>
                    </div>
                </div>
            </Group>
        </>
    );
});

export default ReportDocumentMetadataOverview;
